import {action, makeObservable, observable} from 'mobx';
import BaseStore from '../../../../../../store/domain/base.store';

class UserIdentitiesUIStore extends BaseStore {
    selectedIdentity;
    isAddIdentityModalOpen = false;
    isEditIdentityModalOpen = false;
    isDeleteConfirmOpen = false;

    constructor() {
        super();
        this.setSelectedIdentity(undefined);
        this.closeAddIdentityModal();
        this.closeEditIdentityModal();
        this.closeDeleteConfirm();
        makeObservable(this, {
            selectedIdentity: observable,
            isAddIdentityModalOpen: observable,
            isEditIdentityModalOpen: observable,
            isDeleteConfirmOpen: observable,
            setSelectedIdentity: action,
            openAddIdentityModal: action,
            closeAddIdentityModal: action,
            openEditIdentityModal: action,
            closeEditIdentityModal: action,
            openDeleteConfirm: action,
            closeDeleteConfirm: action
        });
        this.createInitialState();
    }

    setSelectedIdentity = (selectedIdentity) => {
        if (Array.isArray(selectedIdentity)) {
            selectedIdentity = selectedIdentity.length > 0 ? selectedIdentity[0] : undefined;
        }
        this.selectedIdentity = selectedIdentity;
    };

    openAddIdentityModal = () => {
        this.isAddIdentityModalOpen = true;
    };

    closeAddIdentityModal = () => {
        this.isAddIdentityModalOpen = false;
    };

    openEditIdentityModal = () => {
        this.isEditIdentityModalOpen = true;
    };

    closeEditIdentityModal = () => {
        this.isEditIdentityModalOpen = false;
    };

    openDeleteConfirm = () => {
        this.isDeleteConfirmOpen = true;
    };

    closeDeleteConfirm = () => {
        this.isDeleteConfirmOpen = false;
    };
}

const userIdentitiesUIStore = new UserIdentitiesUIStore();
export default userIdentitiesUIStore;
